export const iconFontAwesomeNatureLeaf = (
	<i className="fa-solid fa-leaf"></i>
);
